import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { cleanupExpiredStorage } from './utils/secureStorage';
import { initializeMonitoring } from './utils/monitoring';

// Initialize monitoring before app startup
initializeMonitoring();

// Production initialization
if (process.env.NODE_ENV === 'development') {
  console.log('React app starting...');
  console.log('Environment:', process.env.NODE_ENV);
  console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL ? 'Set' : 'Missing');
}

// Cleanup expired secure storage on app startup
cleanupExpiredStorage();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

try {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
  if (process.env.NODE_ENV === 'development') {
    console.log('React app rendered successfully');
  }
} catch (error) {
  console.error('Failed to render React app:', error);
  
  // Safe DOM creation without innerHTML
  const errorDiv = document.createElement('div');
  errorDiv.style.padding = '20px';
  errorDiv.style.textAlign = 'center';
  
  const title = document.createElement('h1');
  title.textContent = 'Loading Error';
  
  const message1 = document.createElement('p');
  message1.textContent = 'There was an error loading the application.';
  
  const message2 = document.createElement('p');
  message2.textContent = 'Please check the console for details.';
  
  const button = document.createElement('button');
  button.textContent = 'Refresh Page';
  button.onclick = () => window.location.reload();
  
  errorDiv.appendChild(title);
  errorDiv.appendChild(message1);
  errorDiv.appendChild(message2);
  errorDiv.appendChild(button);
  
  document.body.appendChild(errorDiv);
}
